import { render, staticRenderFns } from "./Personality.vue?vue&type=template&id=039ddf65&scoped=true"
import script from "./Personality.vue?vue&type=script&lang=ts"
export * from "./Personality.vue?vue&type=script&lang=ts"
import style0 from "./Personality.vue?vue&type=style&index=0&id=039ddf65&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039ddf65",
  null
  
)

export default component.exports